<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item link :to="{name:'dashboard'}" exact>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link :to="{ name: 'messages' }">
          <v-list-item-action>
            <v-icon>mdi-email</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mesaje</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- <v-list-item link :to="{ name: 'necesar' }">
            <v-list-item-action>
                <v-icon>mdi-toolbox-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Necesar</v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->
        <v-list-group
            prepend-icon="mdi-finance"
            value="true"
        >
            <template v-slot:activator>
                <v-list-item-title>Rapoarte contabile</v-list-item-title>
            </template>
            <v-list-item link :to="{ name: 'raport-incasari-plati' }">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Încasări / plăți</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'raport-incasari-castiguri' }">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Încasări / câştiguri</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'raport-necesar-numerar' }">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Necesar numerar</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'situatii-contabile' }">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Situaţii contabile</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'registru-de-casa' }">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Registru de casă</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block  link :to="{ name: 'logout'}" color="indigo">Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SB Office</v-toolbar-title>
      <v-spacer></v-spacer>

    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-footer color="indigo" app>
      
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
    mounted() {
        this.$store.dispatch('getJudete');
        this.$store.dispatch('getProduse');
        this.$store.dispatch('getManagerGroups');
        this.$store.dispatch('getManagerCompanies');
        this.$store.dispatch('getShops');
    }
  }
</script>